import { AsyncPageRender } from '@components/AsyncComponent';
import { ProtectedRoute, RenderComponent } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import React from 'react';
import { Route } from 'react-router';
import InstantQuoteConfirmation from './Stepper/InstantQuoteConfirmation';
import InstantQuoteStepper from './Stepper/InstantQuoteStepper';

export const routes$ = {
    ListAdmin: AsyncPageRender(() => pageModule(import('./ListAdmin'))),
    ListCustomer: AsyncPageRender(() => pageModule(import('./ListCustomer'))),
    ViewCustomer: AsyncPageRender(() => pageModule(import('./ViewCustomer'))),
};

function Router() {
    return (
        <>
            <Route path={'/instant-quote'} component={RenderComponent(InstantQuoteStepper, true)} />
            <Route exact path={'/instant-quote-confirmation/:id'} component={InstantQuoteConfirmation} />

            <Route exact path={'/instant-quotes'} component={ProtectedRoute(routes$.ListAdmin)} />
            <Route exact path={'/instant-quotes/:order'} component={ProtectedRoute(routes$.ViewCustomer)} />
            <Route exact path={'/quotes'} component={ProtectedRoute(routes$.ListCustomer)} />
            <Route exact path={'/quotes/:order'} component={ProtectedRoute(routes$.ViewCustomer)} />
        </>
    );
}

export default Router;
